import { Snackbar, Slide, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SlideUpTransition = (props) => {
  return <Slide {...props} direction='up' />;
};

type MemberAddItemsToastProps = {
  addedCount: number;
  toastOpen: boolean;
  onClose: () => void;
};

export const MemberAddItemsWithToast = ({ addedCount, toastOpen, onClose }: MemberAddItemsToastProps) => {
  const { t } = useTranslation(['member']);
  const handleToastClose = () => {
    onClose();
  };

  const getBgColor = () => {
    if (addedCount > 0) return 'success.main';
    if (addedCount === 0) return 'warning.main';
    return 'info.main';
  };

  return (
    <Snackbar
      open={toastOpen}
      onClose={handleToastClose}
      autoHideDuration={3000}
      TransitionComponent={SlideUpTransition}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ '&.MuiSnackbar-root': { top: '50%' } }}
    >
      <Typography
        variant='subtitle1'
        sx={{
          backgroundColor: getBgColor(),
          color: 'white',
          px: 2,
          py: 1,
          borderRadius: 2,
          opacity: 0.7,
        }}
      >
        <strong>
          {addedCount > 0 && '+'}
          {addedCount !== 0 && addedCount}
        </strong>{' '}
        {addedCount === 0 && t('member:memberAdvancedSearch.profileAlreadyAdded')}
        {addedCount > 1 && t('member:memberAdvancedSearch.profilesPlural')}
        {addedCount < 2 && addedCount !== 0 && t('member:memberAdvancedSearch.profilesSingular')}
      </Typography>
    </Snackbar>
  );
};
